import { Component } from '@angular/core';
import { FeedbackPlatformCommitteeSelectionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Committee Selections') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformcommitteeselection-form',
    templateUrl: './feedbackplatformcommitteeselection.form.component.html'
})
export class FeedbackPlatformCommitteeSelectionFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformCommitteeSelectionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'committeeSelectionItems', sectionName: 'Committee Selection Items', isExpanded: false }
        ]);
    }
}

